import { UploadsOverview } from '../components/UploadsOverview';
import { useSettingsContext } from '../context/SettingsContext';

export const UploadsRoute = () => {
  const { caseId } = useSettingsContext();

  return <UploadsOverview caseId={caseId} />;
};
